(function () {
  // --------- CONFIG (à éditer) ---------
  // Le(s) libellé(s) de l’option du produit (l’étiquette au-dessus du select)
  const SELECT_WRAPPER_LABELS = ['Poids', 'Weight'];

  // Les valeurs à masquer dans ce select (FR + EN). Correspondance insensible à la casse / accents / espaces.
  const HIDE_LABELS = [
    'Chaudière 3kg',
    '3kg bucket'
    // 'Exemple FR', 'Example EN'
  ];

  // --------- UTILS ---------
  const norm = s => (s||'')
    .toString()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'') // retire accents
    .replace(/\s+/g,' ') // espaces multiples → 1
    .trim()
    .toLowerCase();

  const hideSet = new Set(HIDE_LABELS.map(norm));
  const targetSelectLabels = SELECT_WRAPPER_LABELS.map(norm);

  function isTargetWrapper(wrapperEl){
    const label = wrapperEl.querySelector('label');
    if(!label) return false;
    return targetSelectLabels.includes(norm(label.textContent));
  }

  function findWeightSelect(root=document){
    // Ton HTML montre une structure wrapper + label + select
    const wrappers = [...root.querySelectorAll('#product-variants .selector-wrapper')];
    for (const w of wrappers){
      if (isTargetWrapper(w)) {
        const sel = w.querySelector('select.single-option-selector');
        if (sel) return sel;
      }
    }
    // fallback (si la structure change)
    return root.querySelector('#product-variants select.single-option-selector[data-option="option1"]');
  }

  function removeFromVisibleSelect(root=document){
    const sel = findWeightSelect(root);
    if(!sel) return;

    let removedSomething = false;
    let wasSelectedRemoved = false;

    [...sel.options].forEach(opt=>{
      if (hideSet.has(norm(opt.value)) || hideSet.has(norm(opt.textContent))) {
        if (opt.selected) wasSelectedRemoved = true;
        opt.remove();
        removedSomething = true;
      }
    });

    if (removedSomething && wasSelectedRemoved && sel.options.length){
      sel.selectedIndex = 0;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function removeFromHiddenVariantSelect(root=document){
    // Le select des variants (name="id") — texte = libellé affiché
    const sel = root.querySelector('#product-selectors[name="id"]');
    if(!sel) return;

    let toRemove = [], removedSelected = false;

    [...sel.options].forEach(opt=>{
      if (hideSet.has(norm(opt.textContent))) {
        if (opt.selected) removedSelected = true;
        toRemove.push(opt);
      }
    });

    if (toRemove.length){
      // Choisir une variante valide si la sélection courante est supprimée
      if (removedSelected) {
        const fallback = [...sel.options].find(o => !toRemove.includes(o));
        if (fallback){
          fallback.selected = true;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      toRemove.forEach(o=>o.remove());
    }
  }

  function run(root=document){
    removeFromVisibleSelect(root);
    removeFromHiddenVariantSelect(root);
  }

  function bootstrap(){
    run();

    // Re-run si le thème reconstruit le product form (AJAX / sections)
    const target = document.querySelector('#product-variants') || document.body;
    const mo = new MutationObserver(()=> run());
    mo.observe(target, { childList:true, subtree:true });

    document.addEventListener('shopify:section:load', ()=> run());
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();